import { render, staticRenderFns } from "./SearchEduction.vue?vue&type=template&id=4cced9d8"
import script from "./SearchEduction.vue?vue&type=script&lang=js"
export * from "./SearchEduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports